import * as React from 'react';
import { authCheck } from '../../data/providers/userProvider';

interface IProps {
  children: React.ReactElement;
}

const AuthCheck = (props: IProps): React.ReactElement => {
  const [authChecked, setAuthChecked] = React.useState<boolean>(false);

  /**
   * @description ensure the users authentication status has been checked at least once
   */
  React.useEffect((): (() => void) => {
    const subscriber = authCheck().subscribe((_: null): void => {
      setAuthChecked(true);
    });

    return (): void => {
      subscriber.unsubscribe();
    };
  }, []);

  return authChecked ? props.children : null;
};

export { AuthCheck };
